/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
 */

export const commentBaseClassName = 'tao-comment-txt';
export const commentModeClassName = 'tao-comment-mode';
export const commentsContainerSelector = '.qti-item .qti-extendedTextInteraction .text-container';

/**
 * @returns {HTMLElement[]}
 */
export const getExtendedTextInteractionElements = () =>
    Array.from(document.querySelectorAll('.qti-item .qti-extendedTextInteraction'));

/**
 * @param {String} responseId
 * @returns {String}
 */
export const getExtendedTextInteractionSelector = responseId =>
    `.qti-item .qti-extendedTextInteraction[data-response-id="${responseId}"]`;

/**
 * @param {String} responseId
 * @returns {String}
 */
export const getCommentsContainerSelector = responseId =>
    `${getExtendedTextInteractionSelector(responseId)} .text-container`;

/**
 * @param {String} responseId
 * @param {String?} colorKey
 * @returns {String}
 */
export const getCommentSelector = (responseId, colorKey) => {
    const allCommentsSelector = `${getExtendedTextInteractionSelector(responseId)} .${commentBaseClassName}`;
    return colorKey ? `${allCommentsSelector}[data-color="${colorKey}"]` : allCommentsSelector;
};

/**
 * @param {String} responseId
 * @param {String?} colorKey
 * @returns {HTMLElement[]}
 */
export const getCommentElements = (responseId, colorKey) =>
    Array.from(document.querySelectorAll(getCommentSelector(responseId, colorKey)));

/**
 * @param {HTMLElement} el
 * @returns {String}
 */
export const getResponseIdForElement = el => {
    const interaction = el.closest('.qti-extendedTextInteraction');
    return interaction?.getAttribute('data-response-id');
};
